(function (root) {
  var UF = {
    AC: 'Acre', AL: 'Alagoas', AP: 'Amapá', AM: 'Amazonas', BA: 'Bahia',
    CE: 'Ceará', DF: 'Distrito Federal', ES: 'Espírito Santo', GO: 'Goiás',
    MA: 'Maranhão', MT: 'Mato Grosso', MS: 'Mato Grosso do Sul', MG: 'Minas Gerais',
    PA: 'Pará', PB: 'Paraíba', PR: 'Paraná', PE: 'Pernambuco', PI: 'Piauí',
    RJ: 'Rio de Janeiro', RN: 'Rio Grande do Norte', RS: 'Rio Grande do Sul',
    RO: 'Rondônia', RR: 'Roraima', SC: 'Santa Catarina', SP: 'São Paulo',
    SE: 'Sergipe', TO: 'Tocantins'
  };

  function interpolate(template, vars) {
    return String(template || '').replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, k) {
      return vars[k] == null ? '' : String(vars[k]);
    });
  }

  function digitsCep(str) {
    return String(str || '').replace(/\D/g, '').slice(0, 8);
  }

  function maskCep(str) {
    var d = digitsCep(str);
    if (d.length <= 5) return d;
    return d.slice(0, 5) + '-' + d.slice(5);
  }

  function isValidCep(str) {
    return digitsCep(str).length === 8;
  }

  function ufToProvince(uf) {
    var code = String(uf || '').toUpperCase();
    return UF[code] || String(uf || '');
  }

  function snapshotItems(cart) {
    var items = (cart && cart.items) || [];
    return items.map(function (item) {
      var plan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan
        ? item.selling_plan_allocation.selling_plan.id
        : null;
      return {
        id: item.variant_id,
        quantity: item.quantity,
        properties: item.properties || null,
        selling_plan: plan
      };
    });
  }

  function formatDays(rate, t) {
    var days = rate && rate.delivery_days;
    if (!days || !days.length) return '';
    var min = Number(days[0]);
    var max = Number(days.length > 1 ? days[1] : days[0]);
    if (!min && !max) return '';
    if (min === max) {
      var key = min === 1 ? t.days_one : t.days_other;
      return interpolate(key, { count: min });
    }
    return interpolate(t.days_range, { min: min, max: max });
  }

  function formatPrice(rate, t) {
    var price = rate && rate.price;
    var n = parseFloat(price, 10);
    if (!n) return t.free;
    return String(price);
  }

  function escapeHtml(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function ratesHtml(rates, t, formatMoney) {
    var html = '<ul class="empress-pdp-shipping__list">';
    (rates || []).forEach(function (rate) {
      var days = formatDays(rate, t);
      var priceText = formatPrice(rate, t);
      if (formatMoney && rate && rate.price) {
        var cents = Math.round(parseFloat(rate.price) * 100);
        if (cents > 0) {
          try {
            priceText = formatMoney(cents);
          } catch (e) {}
        }
      }
      html += '<li class="empress-pdp-shipping__item"><span class="empress-pdp-shipping__name">' +
        escapeHtml(rate.name) + '</span><span class="empress-pdp-shipping__price">' +
        escapeHtml(priceText) + '</span>';
      if (days) {
        html += '<span class="empress-pdp-shipping__days">' + escapeHtml(days) + '</span>';
      }
      html += '</li>';
    });
    html += '</ul>';
    return html;
  }

  root.EmpressPdpLib = {
    CEP_KEY: 'empress_pdp_cep',
    digitsCep: digitsCep,
    maskCep: maskCep,
    isValidCep: isValidCep,
    ufToProvince: ufToProvince,
    snapshotItems: snapshotItems,
    formatDays: formatDays,
    formatPrice: formatPrice,
    ratesHtml: ratesHtml
  };
})(typeof window !== 'undefined' ? window : this);
